module.exports = __webpack_public_path__ + "h5/img/bright-start.cb233ce2.png";